const ENDPOINTS = {
  AUTH: {
    LOGIN: "API/authentication/sign_in",
    LOGOUT: "API/authentication/logout",
    CHANGE_PASSWORD:"API/authentication/reset_password",
    REGISTER: "API/authentication/register",
    GET_PROFILE: "API/authentication/get_profile",
    EDIT_PROFILE: "API/authentication/edit_profile",
    UPLOAD_PROFILE: "API/authentication/upload_profile",
  },
  DRIVER: {
    LIST: "API/Driver/listing",
    ADD: "API/Driver/add",
    EDIT: "API/Driver/edit",
    UPDATE: "API/Driver/update",
    DELETE: "API/Driver/delete",
    UPLOAD_PHOTO: "API/Driver/upload_photo",
    UPLOAD_AADHAAR: "API/Driver/upload_aadhaar",
    UPLOAD_DL: "API/Driver/upload_dl",
    APPROVE: "API/Driver/approve",
    DISAPPROVE: "API/Driver/reject"
  },
  DASHBOARD: {
    INFO: "API/Dashboard/tiles"
  },
  USERS:{
    VIEW: "API/Users/view",
    LISTING: "API/Users/listing",
    ADD:"API/Users/add",
    EDIT:"API/Users/edit"
  },
  BUSESMASTER:{
    FETCH_BUSES: "API/Bus/listing",
    ADD_BUS: "API/Bus/add",
    EDIT_BUS: "API/Bus/edit",
    DELETE_BUS: "API/Bus/delete",
    VIEW_BUS: "API/Bus/view"
    ,
    UPLOAD_PHOTO_2: "API/Bus/upload_photo_2",
    UPLOAD_PHOTO_1: "API/Bus/upload_photo_1",
    UPLOAD_PHOTO_3: "API/Bus/upload_photo_3",
    UPLOAD_PHOTO_4: "API/Bus/upload_photo_4",
    UPLOAD_RC: "API/Bus/upload_rc",
    UPLOAD_FITNESS: "API/Bus/upload_fitness",
    UPLOAD_PERMIT: "API/Bus/upload_permit",
    UPLOAD_INSURANCE: "API/Bus/upload_insurance",
    UPLOAD_PUC: "API/Bus/upload_puc",
  },
  MASTER: {
    STATES: "/API/Master/state_list/100",
    CITIES: "/API/Master/city_list",
    RTO_OFFICES: "API/RtoOffice/listing",
    POLICE_STATIONS: "API/PoliceStation/listing",
    SCHOOLS: "API/School/listing",
    SCHOOL_LIST: '/API/Reports/school',
    POLICE_STATIONS_LIST: "API/Reports/police_station",
    // MIS School Details staff report; Driver Management keeps DRIVER.LIST.
    STAFF_REPORT: "API/Reports/driver",
    ROLE_LIST: "/API/Master/role_list",

    CATEGORY: "/API/Master/dcc_type_list",
    FIRM_TYPE: "/API/Master/firm_type_list",
    VEHICLE_TYPE_LIST:"/API/Master/vehicle_type_list"
  },
  CONDUCTOR: {
    LIST: "API/Conductor/listing",
    ADD: "API/Conductor/add",
  },
  VEHICLE: {
    LIST: "API/Vehicle/listing",
    ADD: "API/Vehicle/add",
  },
};

export default ENDPOINTS;
